/** Browse-card location line: "Brooklyn, NY · 2.2 mi" (not street address). */
export function browseLocationLine(b) {
  if (!b) return "";
  const place = [b.city, b.state].filter(Boolean).join(", ");
  const dist =
    b.distance_mi != null && b.distance_mi !== undefined && !Number.isNaN(Number(b.distance_mi))
      ? `${Number(b.distance_mi).toFixed(1)} mi`
      : null;
  if (place && dist) return `${place} · ${dist}`;
  if (place) return place;
  const addr = (b.address || "").trim();
  if (addr && dist) return `${addr} · ${dist}`;
  if (addr) return addr;
  return dist || "";
}

const MODE_LABELS = {
  in_store: "In store",
  delivery: "Delivery",
  remote: "Remote",
};

/** Keywords first (most specific), then service modes. Cap at `limit`. */
export function browseServiceChips(b, limit = 8) {
  const keywords = (b?.keywords || []).map((k) => String(k).trim()).filter(Boolean);
  const modes = (b?.service_modes || [])
    .map((m) => MODE_LABELS[m] || String(m).replace(/_/g, " "))
    .filter(Boolean);
  const seen = new Set();
  const out = [];
  for (const label of [...keywords, ...modes]) {
    const key = label.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(label);
    if (out.length >= limit) break;
  }
  return out;
}

/** Bump when geocoder bias changes so stale ZIP caches are discarded. */
export const LOCATION_CACHE_VERSION = 2;
